// extracted by mini-css-extract-plugin
export var dropdownContainer = "_ru-0";
export var leftAlign = "_ru-4";
export var listItem = "_ru-2";
export var listItemWrapper = "_ru-1";
export var operationText = "_ru-3";